<template>
  <v-card class="my-4">
    <v-dialog v-model="dialog" absolute content-class="dialog-file">
      <v-toolbar class="primary" dark>
        <v-spacer />
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text @click="dialog = false">
            <v-icon>close</v-icon>
            Close
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <iframe :src="url" />
    </v-dialog>

    <v-toolbar color="primary" flat dark>
      <v-toolbar-title> {{ lessonTerm | capitalize }}s </v-toolbar-title>
    </v-toolbar>
    <v-data-table :headers="headers" :items="lessons">
      <template v-slot:body="{ items }">
        <tr v-for="item in items" :key="item.id">
          <td>
            {{ item.name }}
          </td>
          <td
            v-if="headers.filter(h => h.text === 'Activity Sheet').length"
            class="text-center"
          >
            <v-btn
              v-if="item.activity_sheet_url"
              block
              outlined
              color="primary"
              @click="showFrame(item.name, item.activity_sheet_url)"
            >
              View Activity Sheet
            </v-btn>
          </td>
          <td
            v-if="headers.filter(h => h.text === 'Teacher Guide').length"
            class="text-center"
          >
            <v-btn
              v-if="item.lesson_plan_url"
              block
              outlined
              color="primary"
              @click="showFrame(item.name, item.lesson_plan_url)"
            >
              View Teacher Guide
            </v-btn>
          </td>
          <td
            v-if="headers.filter(h => h.text === 'Parent Guide').length"
            class="text-center"
          >
            <v-btn
              v-if="item.teacher_guide_url"
              block
              outlined
              color="primary"
              @click="showFrame(item.name, item.teacher_guide_url)"
            >
              View Parent Guide
            </v-btn>
          </td>

          <td class="text-center">
            <v-btn
              v-if="item.total_slides"
              block
              outlined
              color="primary"
              @click="startLesson(item)"
            >
              {{ `Try ${lessonTerm}` }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import Auth from '@/modules/auth/models/Auth'
import { mapState } from 'vuex'

export default {
  name: 'LessonsTable',
  data() {
    return {
      dialog: false,
      url: ''
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    setTimeout(() => {
      this.$store.state.loading = false
    })
  },
  computed: {
    ...mapState(['lessonTerm']),
    me() {
      return Auth.query()
        .where('type', this.$route.meta.type)
        .first()
    },
    lessons() {
      return Lesson.all()
    },
    headers() {
      let header = [
        {
          text: this.lessonTerm + ' Name',
          align: 'left',
          sortable: true
        }
      ]

      if (!this.lessons.every(l => l.activity_sheet_url === null)) {
        header.push({
          text: 'Activity Sheet',
          align: 'center',
          sortable: false
        })
      }

      if (
        !this.lessons.every(l => l.lesson_plan_url === null) &&
        this.me.type === 'teacher'
      ) {
        header.push({
          text: 'Teacher Guide',
          align: 'center',
          sortable: false
        })
      }

      if (
        !this.lessons.every(l => l.parent_guide === null) &&
        this.me.type === 'parent'
      ) {
        header.push({
          text: 'Parent Guide',
          align: 'center',
          sortable: false
        })
      }

      header.push({
        text: `Try ${this.capitalizeFirstLetter(this.lessonTerm)}`,
        align: 'center',
        sortable: false
      })

      return header
    }
  },
  methods: {
    startLesson(lesson) {
      let slug = lesson.slug
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = `lessons/${this.$route.meta.type}`
      } else {
        base_url = `${process.env.VUE_APP_LESSON}/${this.$route.meta.type}`
      }

      window.open(`${base_url}/${link}?slug=${slug}`)
    },
    showFrame(name, url) {
      this.dialog = true
      this.url = url
    }
  }
}
</script>

<style lang="scss">
.dialog-file.v-dialog--active {
  width: 99vw;
  height: 99vh;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}

.v-data-table-header th {
  text-transform: capitalize;
}
</style>
